/*
 * YAMIWARD — THE SEALED ARCHIVE (封印書庫)
 * Retired designs are sealed: withdrawn from sale, never reprinted, recorded
 * here with their real final counts. Until a drop concludes, the archive
 * holds the live status board plus lore records.
 *
 * INTEGRITY RULE: `sealed` entries with type 'design' must be REAL retired
 * products with REAL final counts. Lore records use type 'lore' and always
 * print "DOCUMENTATION ONLY — NEVER PRINTED". Never fabricate sales data.
 */
(function () {
    'use strict';

    // Live drops. When one concludes, move its designs into SEALED with real counts.
    var AT_LARGE = [
        {
            name: 'DROP 001 — ONI PORTAL DROP', kanji: '第一投下',
            detail: '10 designs across four divisions. Still in circulation.',
            status: 'AT LARGE',
            note: 'When Drop 001 concludes, its designs are sealed here and never reprinted.'
        },
        {
            name: 'WARD INSIGNIA', kanji: '紋章',
            detail: 'The mark of the gate itself.',
            status: 'PERMANENT COLLECTION',
            note: 'Exempt from sealing by order of the Records Office. The gate does not retire.'
        }
    ];

    // type 'design' = real retired product (real counts). type 'lore' = fiction, labeled.
    var SEALED = [
        {
            type: 'lore', n: 'A-001', name: 'THE FIRST MARK', kanji: '初印', faction: 'ward',
            sealedDate: 'BEFORE RECORDS', reason: 'Original banner destroyed the night the Gate first moved.',
            fragment: 'The insignia before the insignia. One banner, hand-inked, hung at the old terminus. It burned the night the Gate relocated, and the Records Office notes — without further comment — that the Gate has never hung anything since. What survives is a partial rubbing and one witness account, filed by a conductor who no longer takes that line.',
            stamp: 'RECORDS PARTIAL'
        },
        {
            type: 'lore', n: 'A-002', name: 'KAGE PROTOCOL ZERO', kanji: '零', faction: 'kage',
            sealedDate: 'SEALED BY DIVISION ORDER', reason: 'The prototype glyph rendered fully. Once.',
            fragment: 'Before the Shadow Protocol there was Protocol Zero: the 影 glyph drawn complete, solid black, edge to edge. It was displayed for one night. The Division does not discuss what attended the unveiling, but the induction sigil has been drawn half-rendered ever since, and the Records Office concurs with this policy enthusiastically.',
            stamp: 'DO NOT RECONSTRUCT'
        },
        {
            type: 'lore', n: 'A-003', name: 'UNIT 07 FLIGHT LOG — PAGE ONE', kanji: '飛行記録', faction: 'phantom',
            sealedDate: 'DATE WITHHELD', reason: 'Both dates on the page are true.',
            fragment: 'The first page of Phantom Unit 07’s flight log records two entries for the same airframe on the same night: one departure, logged and signed, and one return, logged and signed by the same hand. The dates do not agree, and the squadron’s official position is that this is fine. The page is sealed so it stops being photocopied by staff who then request transfers.',
            stamp: 'BOTH ARE TRUE'
        }
    ];

    function el(tag, cls, text) {
        var node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text !== undefined) node.textContent = text;
        return node;
    }

    function factionColor(key) {
        var f = window.YW_CODEX && window.YW_CODEX.factions[key];
        return f ? f.color : '#C9CDD6';
    }

    /* ---------- Status board ---------- */

    function buildStatusBoard(container) {
        var board = el('div', 'archive-board');
        board.appendChild(el('div', 'archive-board-title', 'CIRCULATION STATUS'));
        AT_LARGE.forEach(function (d) {
            var row = el('div', 'archive-board-row');
            var info = el('div', 'archive-board-info');
            var nameLine = el('div', 'archive-board-name', d.name + ' ');
            nameLine.appendChild(el('span', 'archive-board-kanji', d.kanji));
            info.appendChild(nameLine);
            info.appendChild(el('div', 'archive-board-detail', d.detail));
            info.appendChild(el('div', 'archive-board-note', d.note));
            row.appendChild(info);
            var badge = el('span', 'archive-status' + (d.status === 'AT LARGE' ? ' at-large' : ' permanent'), d.status);
            row.appendChild(badge);
            board.appendChild(row);
        });
        container.appendChild(board);
    }

    /* ---------- Sealed records ---------- */

    function buildSealed(container) {
        var grid = el('div', 'archive-grid');
        SEALED.forEach(function (s) {
            var card = el('div', 'archive-card');
            card.style.setProperty('--archive-accent', factionColor(s.faction));

            var top = el('div', 'archive-card-top');
            top.appendChild(el('span', 'archive-card-no', 'RECORD ' + s.n));
            top.appendChild(el('span', 'archive-seal-stamp', 'SEALED'));
            card.appendChild(top);

            var nameLine = el('h3', 'archive-card-name', s.name + ' ');
            nameLine.appendChild(el('span', 'archive-card-kanji', s.kanji));
            card.appendChild(nameLine);

            var rows = el('div', 'archive-rows');
            [['SEALED', s.sealedDate], ['REASON', s.reason]].forEach(function (r) {
                var row = el('div', 'archive-row');
                row.appendChild(el('span', 'archive-label', r[0]));
                row.appendChild(el('span', 'archive-value', r[1]));
                rows.appendChild(row);
            });
            card.appendChild(rows);

            // Redacted preview — click/tap to reveal the fragment.
            var redacted = el('div', 'archive-redacted');
            for (var i = 0; i < 4; i++) {
                var bar = el('span', 'archive-redact-bar');
                bar.style.width = (55 + ((i * 37) % 40)) + '%';
                redacted.appendChild(bar);
            }
            var reveal = el('button', 'archive-reveal-btn', 'UNSEAL PREVIEW +');
            reveal.type = 'button';
            var fragment = el('p', 'archive-fragment', s.fragment);
            fragment.style.display = 'none';
            reveal.addEventListener('click', function () {
                var open = fragment.style.display !== 'none';
                fragment.style.display = open ? 'none' : 'block';
                redacted.style.display = open ? 'flex' : 'none';
                reveal.textContent = open ? 'UNSEAL PREVIEW +' : 'RESEAL —';
            });
            card.appendChild(redacted);
            card.appendChild(fragment);
            card.appendChild(reveal);

            card.appendChild(el('div', 'archive-card-stamp', s.stamp));
            card.appendChild(el('div', 'archive-provenance',
                s.type === 'lore'
                    ? 'ARCHIVE RECORD — DOCUMENTATION ONLY. NEVER PRINTED.'
                    : 'RETIRED DESIGN — FINAL COUNT: ' + s.finalCount + ' UNITS ESCAPED INTO THE WORLD.'));

            grid.appendChild(card);
        });
        container.appendChild(grid);
    }

    /* ---------- Init ---------- */

    function init() {
        var stage = document.getElementById('archive-stage');
        if (!stage) return;
        buildStatusBoard(stage);
        buildSealed(stage);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
